// extracted by mini-css-extract-plugin
export default {"section":"Section_section__U3dNt","isHidden":"Section_isHidden__b3kLV","isMaster":"Section_isMaster__ASK4S"};